import { ERoute } from "@/3514/constants"

/**
 * @deprecated legacy sh1t
 */
export enum ELegacyOnboardingStepUrls {
    PROFILE = "/onboarding",
    VIDEO_STEP = "/video-step",
    MODULE_LIST_STEP = "/module-list",
    DIAGNOSTIC_STEP = "/diagnostic",
    DIAGNOSTIC_RESPONSE_STEPS = "/diagnostic-response",
    REFLECTION_OBJECTIVE_STEP = "/reflection-objective",
    SESSION_HOLD_TIMES_STEP = "/session-hold-times",
    COACH_SELECT_STEP = "/coach-select"
}

/**
 * @deprecated legacy sh1t
 */
export const onboardingUrls: string[] = [
    ERoute.Participant_OnboardingProfile,
    ERoute.Participant_OnboardingVideo,
    ERoute.Participant_OnboardingModules_Legacy,
    ERoute.Participant_OnboardingDiagnostic,
    ERoute.Participant_OnboardingDiagnosticResults_Legacy,
    ERoute.Participant_OnboardingReflection,
    ERoute.Participant_OnboardingHolds,
    ERoute.Participant_OnboardingCoach,
    ERoute.Participant_OnboardingRedirect,
    ...Object.values(ELegacyOnboardingStepUrls)
]
